export const playersList = (match, players) => {
  const balls1 = [],
    balls2 = [];

  for (var i = 0; i < match.innings[0]["1st innings"].deliveries.length; i++) {
    const key = Object.keys(match.innings[0]["1st innings"].deliveries[i]);
    const value = Object.values(match.innings[0]["1st innings"].deliveries[i]);
    value[0].inning = key[0];
    balls1.push(value[0]);
  }

  for (var i = 0; i < match.innings[1]["2nd innings"].deliveries.length; i++) {
    const key = Object.keys(match.innings[1]["2nd innings"].deliveries[i]);
    const value = Object.values(match.innings[1]["2nd innings"].deliveries[i]);
    value[0].inning = key[0];
    balls2.push(value[0]);
  }

  const filteredPlayers = new Set();
  for (var i = 0; i < balls1.length; i++) {
    filteredPlayers.add(balls1[i].batsman);
    filteredPlayers.add(balls1[i].bowler);
    filteredPlayers.add(balls1[i]["non_striker"]);
  }
  for (var i = 0; i < balls2.length; i++) {
    filteredPlayers.add(balls2[i].batsman);
    filteredPlayers.add(balls2[i].bowler);
    filteredPlayers.add(balls2[i]["non_striker"]);
  }

  while (filteredPlayers.size != 22) {
    filteredPlayers.add(players[Math.floor(Math.random() * 315)].Players);
  }
  const playersNames = [...new Set(filteredPlayers)];
  const comPlayers = [];

  playersNames.forEach((player) => {
    const ele = players.find((pla) => pla.Players === player);
    if (ele) {
      comPlayers.push({ player, score: ele["Credit Value"] });
    }
  });

  return {
    balls1,
    balls2,
    players:comPlayers,
  };
};
